window.addEventListener('DOMContentLoaded', function () {
  function initSideNav() {
    function expandParent($current) {
      const $parentLi = $current.parentNode.closest('li')
      if ($parentLi) {
        $parentLi.classList.add('is-expanded')
        expandParent($parentLi)
      }
    }
    
    const $kbc = document.querySelector('.kbc.is-initializing')
    if ($kbc) $kbc.classList.remove('is-initializing')

    const $rootElement = document.querySelector('.aps-side-nav > a:first-child')
    const $menu = document.querySelector('.aps-side-nav > ul')

    $rootElement.addEventListener('click', function (ev) {
      if (window.innerWidth < 1300) {
        ev.preventDefault()
        $rootElement.classList.toggle('is-expanded')
        $menu.classList.toggle('is-expanded')
      }
    })

    let isCurrentSet = false
    Array.from($menu.querySelectorAll('li')).reverse().forEach(
      $li => {
        const $a = $li.querySelector('a')
        const $img = $li.querySelector('img')
        if ($a) {
          // Replace any &nbsp; that Kentico may have spat out
          $a.textContent = $a.innerHTML.split('&nbsp;').join(' ')
          let isCurrent
          if (!isCurrentSet) {
            const pathname = window.location.pathname.toLowerCase()
            isCurrent = $a.href && $a.href.toLowerCase().endsWith(pathname)
            if (isCurrent) {
              $li.classList.add('is-current')
              isCurrentSet = true
            }
          }
          const numDescendants = $li.querySelectorAll('ul > li').length
          if (numDescendants) {
            $li.querySelector('ul').style.maxHeight = 64 * numDescendants + 'px'
            $li.classList.add('is-expandable')
            if (isCurrent) $li.classList.add('is-expanded')
          }
          if ($img) {
            const $button = document.createElement('button')
            $button.addEventListener('click', function (ev) {
              ev.preventDefault()
              $li.classList.toggle('is-expanded')
            })
            $button.appendChild($img)
            $li.prepend($button)
          }
        }
      }
    )
    const $current = $menu.querySelector('.is-current')
    if ($current) expandParent($current)
  }

  function initAccordion() {
    Array.from(document.querySelectorAll('.aps-accordion__item')).forEach(
      $item => {
        var $heading = $item.querySelector('.aps-accordion__heading')
        var $content = $item.querySelector('.aps-accordion__content')
        $heading.addEventListener('click', function () {
          var isExpanded = $item.classList.toggle('is-expanded')
          $content.style.height = isExpanded ? $content.scrollHeight + 'px' : '0'
        })
      }
    )
  }

  // Only initialize aps-side-nav if not embedded in an iFrame
  if (window.top === window.self && document.querySelectorAll('.aps-inner').length) {
    try {
      initSideNav()
    } catch (e) {
      console.error('Failed to initialize aps-side-nav!')
      console.error(e)
    }
    initAccordion()
  } else if (document.querySelectorAll('.aps-accordion__item').length) {
    initAccordion()
  }
})
